import sortBy from 'lodash/sortBy';
import Vue from "vue";

export default {
    state: {
        tags: []
    },

    getters: {
        all: (state) => {
            return sortBy(state.tags, 'name');
        }
    },

    mutations: {
        add: (state, tag) => {
            state.tags.push(tag);
        },

        update: (state, tag) => {
            let originalTag = state.tags.find(t => t.id === tag.id);

            if (originalTag) {
                originalTag.name = tag.name;
            } else {
                state.tags.push(tag);
            }
        },

        delete: (state, tag) => {
            state.tags = state.tags.filter(t => t.id !== tag.id);
        },

        setTags(state, tags) {
            Vue.set(state, 'tags', tags);
        }
    },

    actions: {}
}